import styles from "./ShipFromStore.module.scss";

import { ShipFromStoreDrawer } from "./ShipFromStoreDrawer";
import { DeliveryOutlined as Delivery } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/DeliveryOutlined";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import { useRef, useState } from "react";
import { dispatchAnalyticsEvent } from "@/utils";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

interface Props {
  price: string;
  freeDeliveryThreshold: number;
  useNewDeliverFromStoreMesssaging: boolean;
}

export function ShipFromStoreUI({
  price,
  freeDeliveryThreshold,
  useNewDeliverFromStoreMesssaging = false,
}: Props) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isStandardDelivery = Number(price) < freeDeliveryThreshold;
  const isDrawerInteractionDispatched = useRef(false);

  function dispatchOverLayOpenedEvent() {
    dispatchAnalyticsEvent("shipfromstore.overlay", {}, {});
  }

  function dispatchMonetateEvent() {
    dispatchMonetateQEvent("standard-pdp-delivery-from-store-sidedrawer-open");
  }

  function handleClick(): void {
    if (!isDrawerInteractionDispatched.current) {
      dispatchOverLayOpenedEvent();
      dispatchMonetateEvent();
      isDrawerInteractionDispatched.current = true;
    }
    setIsDrawerOpen(true);
  }

  const deliveryFromStoreMessage = useNewDeliverFromStoreMesssaging
    ? isStandardDelivery
      ? `Sent directly from one of our stores using £4.50 standard delivery`
      : `Sent directly from one of our stores using free standard delivery`
    : isStandardDelivery
      ? `This item is only available for delivery from one of our stores. Standard delivery £4.50.`
      : `This item is only available for delivery from one of our stores. Free Standard Delivery.`;

  return (
    <>
      <ListItem
        label={"Delivery from store"}
        description={
          <ul className={styles.infoList}>
            <li>{deliveryFromStoreMessage}</li>
            <li>Special offers may not be available</li>
          </ul>
        }
        leadingIcon={<Delivery size="medium" />}
        trailingIcon={<ArrowRight size="medium" />}
        showBottomBorder={true}
        showTopBorder={true}
        onClick={handleClick}
        className={styles.bottomMargin}
      />
      <ShipFromStoreDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        isStandardDelivery={isStandardDelivery}
      />
    </>
  );
}
